import { Stack, Card, Typography, Box, IconButton, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router';
import { HeaderBreadcrumbs, ScreenError, ScreenWrap } from '../../components';
import { Api } from '../../api';
import { Model } from '../../models';

/** Programs first; opening one shows its weeks (ProgramWeeksScreen). */
export default function ProgramOverviewScreen() {
  const api = Api.Program.useReadCollectionAsAdmin();

  if (api.error) return <ScreenError {...api} />;

  const programs =
    api.data?.member?.slice().sort((a, b) => a.number - b.number) || [];

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs title="Program Content" />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: 2,
          }}
        >
          {programs.map((program) => {
            const status = Model.Program.PROGRAM_STATUS_OPTIONS.find(
              (o) => o.value === program.status,
            );
            return (
              <Card
                key={program.id}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  px: 3,
                  py: 2,
                  boxShadow: 'none',
                  border: '1px solid #F1F1F4',
                  borderRadius: 2,
                  background: '#fff',
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  component={Link}
                  to={`/program/${program.id}`}
                  sx={{ textDecoration: 'none' }}
                >
                  <Stack>
                    <Typography variant="caption" color="text.secondary">
                      Program {program.number}
                    </Typography>
                    <Typography
                      sx={{ color: '#1A1A1A', fontWeight: 500, fontSize: 16 }}
                    >
                      {program.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {program.totalWeeks} weeks
                    </Typography>
                  </Stack>
                  <IconButton>
                    <ArrowForwardIcon color="primary" />
                  </IconButton>
                </Stack>
                <Stack direction="row" alignItems="center" gap={1}>
                  <Chip
                    size="small"
                    label={status?.label ?? program.status}
                    color={status?.color ?? 'default'}
                    sx={
                      program.status === 'draft'
                        ? { backgroundColor: '#DE7101' }
                        : undefined
                    }
                  />
                  <Typography variant="caption" color="text.secondary">
                    {status?.description}
                  </Typography>
                </Stack>
              </Card>
            );
          })}
        </Box>
      </Stack>
    </ScreenWrap>
  );
}
